<app-flight-card-mobile [content]="'flex'">
  <!-- Título -->
  <ng-container title>
    <ng-container *ngIf="isFlight(); else notFlightTitle">
      <ng-container *ngIf="data | getFormTitle:true as title">
        <ng-container [ngSwitch]="title.type">
          <ng-container *ngSwitchCase="'title'">{{ title.value }}</ng-container>
          <ng-container *ngSwitchCase="'date'">{{ title.value }}</ng-container>
          <ng-container *ngSwitchCase="'airports'">
            {{ title.value[0] }}
            <app-custom-icon
              [iconPath]="'assets/icons/general-icons.svg'"
              [imageName]="'icon-chevron-right'"
            ></app-custom-icon>
            {{ title.value[1] }}
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #notFlightTitle>
      {{ data.title }}
    </ng-template>
  </ng-container>

  <!-- Badge -->
  <ng-container subtitle>
    <div class="form-type mt-2" [ngClass]="'type-' + (getFormType() || 'unknown')">
      {{ getFormType() | uppercase }}
    </div>
  </ng-container>

  <!-- Status (solo para flight) -->
  <ng-container status *ngIf="isFlight()">
    <app-frat-status [flight]="data"></app-frat-status>
  </ng-container>

  <!-- Contenido principal -->
  <ng-container content>
    <!-- FLIGHT -->
    <ng-container *ngIf="isFlight()">
      <ng-container *ngFor="let field of data.fields">
        <ng-container *ngIf="field | fieldExcludesFilter:'fieldName':(data | getFormTitle:true)?.fields">
          <ng-container *ngIf="(data | flightField:field.fieldName) as value">
            <div class="data-field">
              <span>{{ field.label }}:
                <span class="font-bold">{{ value }}</span>
              </span>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- ISSUE -->
    <ng-container *ngIf="isIssue()">
      <div class="data-field">
        <p>
          You were subscribed to a risk mitigation by
          <span class="font-bold">{{ data.creator?.abbreviatedName || (data.creator | userAbbreviatedName) }}</span>
        </p>
      </div>
    </ng-container>

    <!-- PROMOTION -->
    <ng-container *ngIf="isPromotion()">
      <div class="data-field">
        <p>
          {{ data.creator.abbreviatedName }} sent you a safety promotion on
          <span class="font-bold">{{ dateUtils.formatDateWithConditionalYear(data.sentDate) }}</span>
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="isTask()">
      <div class="data-field">
        <p>
          {{ data.title }}
          <span> Due Date <b>{{ dateUtils.formatDateWithConditionalYear(getTaskDueDate()) }}</b>. Status: <b>{{ data.status }}</b></span>
          @if(getTaskTotalAssociations() > 0) {
            <span class="ml-1">Associations: <b>{{ getTaskTotalAssociations() }}</b></span>
          }
        </p>
      </div>
    </ng-container>
  </ng-container>


  <!-- CTA -->
  <ng-container actions>
    <app-flight-card-cta
      class="w-full"
      actions
      [flight]="data"
      [type]="type"
      [isEditable]="showEdit"
      [canBeArchived]="true"
    ></app-flight-card-cta>
  </ng-container>
</app-flight-card-mobile>
